/* unplugin-vue-components disabled */import { render } from "./ActivityDetails.vue?vue&type=template&id=c95db0be&scoped=true"
import script from "./ActivityDetails.vue?vue&type=script&lang=js"
export * from "./ActivityDetails.vue?vue&type=script&lang=js"

import "./ActivityDetails.vue?vue&type=style&index=0&id=c95db0be&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95db0be"]])

export default __exports__